import api from './axios';

export const fetchClientDashboard = () =>
  api.get('/client/dashboard').then((r) => r.data);

export const fetchServiceHistory = () =>
  api.get('/client/history/appointments').then((r) => r.data);

export const fetchOrderHistory = () =>
  api.get('/client/history/orders').then((r) => r.data);

export { submitReview } from './reviews';

export const reorderItems = (orderId) =>
  api.post(`/client/orders/${orderId}/reorder`).then((r) => r.data);
